<div>
  <salonmonster-stripe-payment *ngIf="clientBookingPayments" (onBookingSave)="onSave()" mode="cardrequest" [refreshStripe]="refreshStripe" [client]="client"></salonmonster-stripe-payment>
</div>